import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import pj from '../package.json';

const authLink = setContext((_, { headers = {} }) => {
  return {
    headers: {
      ...headers,
      // Browser will overwrite this header with select browser language if this header value is not set
      'Accept-Language': headers?.['Accept-Language'] ?? 'is-IS',
    },
  };
});

export const getClient = (graphQlBaseUrl: string, clientNameIv?: string) => {
  let returnName = '';
  switch (clientNameIv) {
    case 'Web_Personal':
    case 'Web_Personal_Test':
      returnName = 'idp-personal';
      break;
    case 'Web_Corporate':
    case 'Web_Corporate_Test':
      returnName = 'idp-corporate';
      break;
    case 'App_Ui':
    case 'App_Ui_Test':
      returnName = 'idp-app';
      break;
    case 'Web_Mobile_Ui':
    case 'Web_Mobile_Ui_Test':
      returnName = 'idp-lis';
      break;
    default:
      returnName = 'idp-thirdparty';
    // Web_SelfService might be added to graphql later
  }
  const httpLink = new HttpLink({
    uri: graphQlBaseUrl,
  });

  return new ApolloClient({
    name: returnName,
    version: pj.version,
    cache: new InMemoryCache(),
    link: ApolloLink.from([authLink, httpLink]),
  });
};
